import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stateFilter'
})
export class StateFilterPipe implements PipeTransform {

  transform(arr: any, searchItem: any): any {
    let transformedList = arr;
    let searchKey = searchItem.toLowerCase();
    if (searchKey) {
      transformedList = transformedList.filter((element: any) => {
        if (searchKey === 'inside') {
          if (element?.state?.toLowerCase()?.includes(searchKey) || element?.state?.toLowerCase()?.includes('untagged') ||
            element?.state?.toLowerCase()?.includes('mismatch_inlane') || element?.state?.toLowerCase()?.includes('delayed')) {
            return element;
          }
        } else if (element?.state?.toLowerCase()?.includes(searchKey)) {
          return element;
        }
      });
    }
    return transformedList;
  }
}
